import React from "react";
import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";

const IndexIndecator = (props) => {
  const { greenTextValue, redTextValue, greyTextValue } = props;

  return (
    <>
      <div
        className="row align-items-center fw-600"
        style={{ padding: "12px 0px" }}
      >
        {/* Column for "<= 90 INDEX" */}
        <div className="col-auto d-flex align-items-center">
          <Tag
            className="me-2"
            style={{
              backgroundColor: "#DC3545",
              borderRadius: "25%",
              width: "20px",
              height: "16px",
            }}
          />
          <span className="ms-1 text-danger">
            &lt; {redTextValue || `90`} Index
          </span>
        </div>
        {/* Column for "91 - 109 INDEX" */}
        <div className="col-auto d-flex align-items-center">
          <Tag
            className="me-2"
            style={{
              backgroundColor: "#666666",
              borderRadius: "25%",
              width: "20px",
              height: "16px",
            }}
          />
          <span className="ms-1 text-dark-gray">
            {greyTextValue || `91 - 109`} Index
          </span>
        </div>
        {/* Column for ">= 110 INDEX" */}
        <div className="col-auto d-flex align-items-center">
          <Tag
            className="me-2"
            style={{
              borderRadius: "25%",
              width: "20px",
              height: "16px",
              backgroundColor: "#198755",
            }}
          />
          <span className="ms-1 text-success">
            &gt; {greenTextValue || `110`} Index
          </span>
        </div>
      </div>
      <Divider type="solid" />
    </>
  );
};

export default IndexIndecator;
